import { InputWord } from "./InputWord";
export { InputWord };
export default InputWord;
